enum UpgradeProgramType {
  GEMINI = 'gemini_upgrade_program',
  ADAPTER_EXCHANGE = 'adapterExchange',
  KP2NFC = 'kp2nfc',
  CABLE_EXCHANGE = 'CableExchange',
  KP2NFC_TAMPER_EXCHANGE = 'kp2_nfc_tamper_exchange',
}

export default UpgradeProgramType;
